var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tui-switch', _vm.value ? 'tui-switch-checked' : 'tui-switch-no-checked']})}
var staticRenderFns = []

export { render, staticRenderFns }